import { observer } from 'mobx-react';
import ModalReactions from '../../../../Modal/ModalReactions';
import { LearningCollectionResource } from '../../../Types';
import Modal from './Modal';
import InviteParticipantStore from './Store';

interface Props {
  learningCollectionResource: LearningCollectionResource;
  inviteParticipantStore: InviteParticipantStore;
}

function InviteParticipantModal({ inviteParticipantStore, learningCollectionResource }: Props) {
  return (
    <>
      <Modal
        store={inviteParticipantStore}
        learningCollectionResource={learningCollectionResource}
      />
      <ModalReactions store={inviteParticipantStore.modalStore} />
    </>
  );
}

export default observer(InviteParticipantModal);
